import {DEFAULT_CURRENCY} from '../../../../../../types/constants.ts'
import {isLineFilled} from './invoiceLines.ts'
import {toBackendVat} from '../../CatalogPage/catalogApi.ts'
import {
    CreateRecurringSeriesRequest,
} from '../../RecurringInvoicesPage/types/recurringInvoice.ts'
import {InvoiceCustomer, InvoiceLineItem} from '../types.ts'
import type {PaymentTerm, RecurringCadence} from '../../../../../../generated/enums.ts';

const MAX_DESCRIPTION_LENGTH = 255

export class CannotBuildRecurringSeriesError extends Error {}

export function buildRecurringSeriesRequest(input: {
    customer: InvoiceCustomer | null,
    bankAccountId: string | null,
    lines: InvoiceLineItem[],
    invoiceDateISO: string,
    paymentTerm: PaymentTerm,
    cadence: RecurringCadence,
}): CreateRecurringSeriesRequest {
    const {customer, bankAccountId, lines, invoiceDateISO, paymentTerm, cadence} = input

    if (!customer || customer.isAdHoc || !customer.id) {
        throw new CannotBuildRecurringSeriesError('Een terugkerende factuur heeft een opgeslagen klant nodig.')
    }
    if (!bankAccountId) {
        throw new CannotBuildRecurringSeriesError('Een terugkerende factuur heeft een bankrekening nodig.')
    }

    const filledLines = lines.filter(isLineFilled)
    if (filledLines.length === 0) {
        throw new CannotBuildRecurringSeriesError('Een terugkerende factuur heeft minstens één regel nodig.')
    }

    return {
        customer_name: customer.name.trim(),
        customer_id: customer.id,
        bank_account_id: bankAccountId,
        description: seriesDescription(filledLines),
        cadence,
        payment_term: paymentTerm,
        first_invoice_on: invoiceDateISO,
        first_invoice_already_issued: true,
        auto_send: true,
        lines: filledLines.map((line) => ({
            description: line.description.trim(),
            quantity: line.quantity ?? 1,
            unit: line.unit,
            unit_price_net_cents: Math.round((line.unitPrice ?? 0) * 100),
            currency: DEFAULT_CURRENCY,
            ...toBackendVat(line.vat),
            catalogue_item_id: line.catalogueItemId,
        })),
    }
}

function seriesDescription(filledLines: InvoiceLineItem[]): string {
    const first = filledLines[0].description.trim()
    const description = filledLines.length > 1
        ? `${first} + ${filledLines.length - 1} regel${filledLines.length > 2 ? 's' : ''}`
        : first

    return description.slice(0, MAX_DESCRIPTION_LENGTH)
}
